<template>
    <div class="Addconditions">
        <el-row>
            <el-col :span="11">
                <el-form :model="params" :rules="rules" ref="params">
                    <el-form-item :label="$t('original.languages554')" prop="conditionName" label-width="100px">
                        <el-input v-model.trim="params.conditionName" :placeholder="$t('original.languages4')" style="width:240px"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('original.languages560')" prop="condition" label-width="100px">
                        <div style="display: flex;">
                            <div style="width:100%;display: flex;"><textarea :placeholder="$t('original.languages561')" @blur="campaignNameBlur" v-model="params.condition" class="conditionsarea"></textarea></div>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('original.languages556')" prop="isActive"  label-width="100px">
                        <el-radio-group v-model="params.isActive">
                            <el-radio :label="0">{{$t('original.languages163')}}</el-radio>
                            <el-radio :label="1">{{$t('original.languages162')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12" :offset="1">
                <el-row style="margin-top: 60px;"><p class="title">配置规范示例</p></el-row>
                <el-row style="padding-top: 10px;color: #282828;">请参照示例样式，如：([90项症状清单（SCL90）_抑郁平均分]>3) or ([抑郁自评量表（SDS）_总分原始分]>50)；</el-row>
                <el-row style="margin-top: 20px;"><p class="title">配置参数名称格式如下：</p></el-row>
                <el-row style="padding-top: 10px;color: #282828;">参数名称：'['+量表名称+'_'+因子名称（量表总分用总分表示）+分数类型（原始分/标准分/平均分）+']'</el-row>
                <el-row style="color: #F24B4E;">注意：参数名称不能有空格，建议通过以下选择按钮进行辅助输入。</el-row>
                <el-row style="margin-top: 20px;"><p class="title">配置因子格式如下：</p></el-row>
                <el-row style="padding-top: 10px;color: #282828;">
                    规则：如要选择m个因子中的n个满足条件(m>n),可采用 {《条件1》+《条件2》+《条件3》+...+《条件m》}>n 的方式。<br/>
                    示例：筛选90量表其中任意2个因子平均分>3可表示为：{《[90项症状清单（SCL90）_躯体化平均分]>3》+《[90项症状清单（SCL90）_强迫症状平均分]>3》+《[90项症状清单（SCL90）_人际关系敏感平均分]>3》}>2</el-row>
                <el-row style="margin-top: 20px;"><p class="title">配置预警等级格式如下：</p></el-row>
                <el-row style="padding-top: 10px;color: #282828;">
                    规则：预警等级只能用=连接，如要筛选多个预警等级,可采用以下方法<br/>
                    示例：{《[90项症状清单（SCL90）_预警等级]='重度'》+《[90项症状清单（SCL90）_预警等级]='较重'》}>=1</el-row>
                <el-row style="margin-top: 20px;"><p class="title">题目相关配置格式如下：</p></el-row>
                <el-row style="padding-top: 10px;color: #282828;">
                    题目得分、题目选项默认用=连接,其他符合请自行修改，但要符合规则，这里筛选仅针对单选的题目。<br/>
                    题目选项筛选示例：[90项症状清单（SCL90）_题目选项1]='A'<br/>
                    题目得分筛选示例：[90项症状清单（SCL90）_题目得分1]=1
                </el-row>
                <el-col style="color: #F24B4E;">注意：以上所有符号均为英文半角符号。</el-col>
                <el-row style="margin-top: 40px;">
                    <el-col :span="5">
                        <el-row style="margin-top: 10px;"><el-button type="primary" @click="dialogVisible=true" class="choosebtn">选择量表</el-button></el-row>
                        <el-row style="margin-top: 10px;"><el-button type="primary" @click="clickfactor" class="choosebtn">选择因子</el-button></el-row>
                        <el-row style="margin-top: 10px;">
                            <el-popover  placement="top"  width="400"  v-model="warndialog"  trigger="manual">
                                <div class="popover">
                                    <div class="list">
                                        <p :class="searchmodel==item.crisisWarningResult?'item on ':'item'" v-for="item in Warninglevel" @click="searchmodel=item.crisisWarningResult">{{ item.crisisWarningResult }}</p>
                                    </div>
                                    <div style="margin-top:10px;">
                                        <el-button type="primary" style="margin-left: 10px;" @click="handclickletoptic">保存</el-button>
                                        <el-button @click="warndialog=false;">取消</el-button>
                                    </div>
                                </div>
                            <el-button type="primary"  slot="reference" class="choosebtn" @click="handleclickwarn">选择预警等级</el-button>
                            </el-popover>
                        </el-row>
                        <el-row style="margin-top: 10px;">
                            <el-popover  placement="top"  width="400"  v-model="topicdialog"  trigger="manual">
                                    <div class="popover">
                                        <div class="list">
                                            <p :class="searchmodel==item.questionLetter?'item on ':'item'" v-for="item in questionData" @click="searchmodel=item.questionLetter">{{ item.questionLetter }}</p>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <el-button type="primary" style="margin-left: 10px;" @click="handclickletoptic">保存</el-button>
                                            <el-button @click="topicdialog=false;">取消</el-button>
                                        </div>
                                    </div>
                                    <el-button type="primary" slot="reference" class="choosebtn" @click="opentopic">选择题目选项</el-button>
                            </el-popover>
                        </el-row>

                        <el-row style="margin-top: 10px;">
                            <el-popover  placement="top"  width="400"  v-model="answerdialog"  trigger="manual">
                                    <div class="popover">
                                        <div class="list">
                                            <p :class="searchmodel==item.answerScore?'item on ':'item'" v-for="item in answerData" @click="searchmodel=item.answerScore">{{ item.answerScore }}</p>
                                        </div>

                                        <div style="margin-top:10px;">
                                            <el-button type="primary" style="margin-left: 10px;" @click="handclickletoptic">保存</el-button>
                                            <el-button @click="answerdialog=false;">取消</el-button>
                                        </div>
                                    </div>
                                    <el-button type="primary" slot="reference" class="choosebtn" @click="openanswer">选择题目答案</el-button>
                            </el-popover>
                        </el-row>
                    </el-col>
                    <el-col :span="12" >
                        <ul class="labellist">
                            <li v-for="item in labellist" :style="{opacity:item==''?0:1}" @click="clicklabel(item)">{{ item }}</li>
                        </ul>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-button type="primary" @click="submitForm('params')">{{$t('original.languages59')}}</el-button>
        <el-button @click="$router.go(-1)">{{$t('original.languages164')}}</el-button>

        <!-- 选择量表弹窗 -->
        <el-drawer  class="scale_right" size="40%" :visible.sync="dialogVisible" :with-header="false" :before-close="handleClose">
          <el-input  class="scale_right_input" style="width: 60% !important;  margin-left: 20px; margin-top: 30px; padding-right: 20px;"  clearable v-model="formInline.Tiaojian"  placeholder="输入量表名称搜索"></el-input>
          <el-button type="primary" @click="querypaper"> 搜索</el-button>
          <el-button type="primary" @click="confirmdrawer"> 确定</el-button>
          <div class="scale_list">
            <el-tabs tab-position="left">
              <el-tab-pane class="cvde" style="text-align: left !important;" v-for="item in scalelist" :key="item.message" :label="item.PaperName">
                <el-checkbox-group v-model="scaleitem" v-for="(item, index) in item.LiPaper" :key="index" size="small" @change="changecheck">
                  <el-checkbox :label="item" :name="item.PaperName"> {{ item.PaperName }}</el-checkbox>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-drawer>

        <!-- 选择因子 factorList-->
        <el-drawer  class="scale_right" size="40%" :visible.sync="factordialog" :with-header="false" :before-close="handleClose">
            <div style="margin: 20px;">
                <el-button type="primary" @click="confirmfactor"> 确定</el-button>
                <el-button @click="factordialog=false"> 取消</el-button>
            </div>

            <el-tree :data="factorList" show-checkbox ref="factortree" node-key="id" default-expand-all :props="{label:'id',value:'factorScore',children:'factorScoreList'}">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span >{{ data.factorScore}}</span>
                </span>
            </el-tree>
        </el-drawer>
    </div>
</template>
<script>
    export default{ 
        name:'Addconditions',
        data() {
            return {
                formInline: {Tiaojian: ''},
                labellist:['<','<=','>=','>','《','7','8','9','(',')','{','}','》','4','5','6','+','-','*','/','=','1','2','3','and','or','!=','','','0','.','del'],
                params:{
                    conditionName:'',
                    condition:'',
                    isActive:'',
                    paperCode:[]
                },
                conditionID:this.$route.query.conditionID,
                rules:{
                    conditionName: [{ required: true, message: '请输入条件名称', trigger: 'blue' }],
                    condition: [{ required: true, message: '请添加条件配置', trigger: 'change' }],
                    isActive: [{ required: true, message: '请选择是否启用', trigger: 'change' }]
                },
                dialogVisible:false,
                factordialog:false,
                topicdialog:false,
                warndialog:false,
                answerdialog:false,
                scalelist:'',
                checkboxGroup1:[],
                scaleitem:[],
                scaleName:'',
                cursorPosition:'',
                factorList:[],
                questionData:[],
                answerData:[],
                Warninglevel:[],
                searchmodel:''
            }
        },
        created() {
            if(this.conditionID){
                this.viewpapercondition();
            }
            this.querypaper();
        },
        methods: {
            // 详情
            viewpapercondition(){
                this.$Http_Post('querypaper/viewpapercondition',{conditionID:this.conditionID}).then(res=>{
                    if(res.Code==0){
                        this.params.conditionName=res.Data.conditionname;
                        this.params.condition=res.Data.condition;
                        this.params.isActive=res.Data.isActive;
                        this.params.paperCode=res.Data.paperCode;
                    }
                })
            },
            // 获取量表
            querypaper(){
                this.$Http_Post('ScaleIssue/GetShowScale',this.formInline).then(res=>{
                    if(res.Code==200 || res.Code==0){
                        this.scalelist=res.Data;
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                });
            },
            // 选择量表
            changecheck(val){
                this.scaleitem=[];
                if(val.length>0){
                    this.scaleitem.push(val[val.length-1]);
                }
            },
            // 量表确认按钮
            confirmdrawer(){
                this.params.condition=''
                if(this.scaleitem.length>0){
                    this.scaleName=this.scaleitem[0].PaperName;
                    this.params.paperCode=this.scaleitem[0].PaperCode;
                    this.queryfactor();
                    this.querycrisiswarning();
                    this.queryquestion();
                    this.queryanswer();
                }else{
                    this.scaleName='';
                    this.params.paperCode='';
                }
                this.dialogVisible=false;
            },
            // 关闭弹窗
            handleClose(val){
                this.dialogVisible=false;
            },
            // 获取因子列表
            queryfactor(){
                this.$Http_Post('querypaper/queryfactor',{paperCode:this.params.paperCode}).then(res=>{
                    if(res.Code==0){
                        this.factorList=res.Data;
                    }
                })
            },
            // 获取预警等级
            querycrisiswarning(){
                this.$Http_Post('querypaper/querycrisiswarning',{paperCode:this.params.paperCode}).then(res=>{
                    if(res.Code==0){
                        this.Warninglevel=res.Data;
                    }
                });
            },
            // 获取量表问题
            queryquestion(){
                this.$Http_Post('querypaper/queryquestion',{paperCode:this.params.paperCode}).then(res=>{
                    if(res.Code==0){
                        this.questionData=res.Data;
                    }
                })
            },
            // 获取量表答案 
            queryanswer(){
                this.$Http_Post('querypaper/queryanswer',{paperCode:this.params.paperCode}).then(res=>{
                    if(res.Code==0){
                        this.answerData=res.Data;
                    }
                })
            },
            // 打开因子弹窗
            clickfactor(){
                if(this.params.paperCode==''){
                    this.$message({type: 'error', message:'请先选择量表'});
                    return false;
                }
                this.factordialog=true;
            },
            // 打开题目选项弹窗
            opentopic(){
                if(this.params.paperCode==''){
                    this.$message({type: 'error', message:'请先选择量表'});
                    return false;
                }
                this.topicdialog=true;
            },
            // 打开预警等级
            handleclickwarn(){
                if(this.params.paperCode==''){
                    this.$message({type: 'error', message:'请先选择量表'});
                    return false;
                }
                this.warndialog=true;
            },
            openanswer(){
                if(this.params.paperCode==''){
                    this.$message({type: 'error', message:'请先选择量表'});
                    return false;
                }
                this.answerdialog=true;
            },
            confirmfactor(){
                let nodes=this.$refs.factortree.getCheckedNodes();
                if(nodes.length>0){
                    for(let item of nodes){
                        if(item.id){
                            this.params.condition+='['+this.scaleName+'_'+item.factorScore+']'
                        }
                    }
                }
                this.factordialog = false;
            },
            
            campaignNameBlur(e){
                this.cursorPosition = e.srcElement.selectionStart;
            },

            //添加标签
            clicklabel(val){
                if(val=='del'){
                    if(typeof this.cursorPosition!="number"){
                        this.cursorPosition = this.params.condition.length;
                    }
                    this.cursorPosition -= 1;
                    this.params.condition = this.params.condition.replace(this.params.condition[this.cursorPosition],'');
                }else{
                    if (typeof this.cursorPosition == "number") {//插入到指定光标处
                        let right = this.params.condition.slice(0, this.cursorPosition)
                        let left = this.params.condition.slice(this.cursorPosition);
                        this.cursorPosition=(right + val).length;
                        this.params.condition = right + val + left
                    } else {//没有指定插入直接添加到最后
                        this.params.condition += val;
                    }
                }
            },
            //
            handclickletoptic(val){
                this.params.condition += '['+this.scaleName+this.searchmodel+']';
                this.topicdialog=false;
                this.answerdialog=false;
                this.warndialog=false;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid && this.params.paperCode!='') {
                    let URL='';
                    if(this.conditionID){
                        URL='querypaper/updatepapercondition';
                        this.params['conditionID']=this.conditionID;
                    }else{
                        URL='querypaper/savepapercondition';
                    }
                   this.$Http_Post(URL,this.params).then(res=>{
                    if(res.Code==0){
                        this.$message({type: 'success', message:res.Message});
                        this.$router.go(-1);
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                   })
                } else {
                    this.$message({type: 'error', message:'请填写完整信息'});
                    return false;
                }
                });
            },
        },
    }
</script>
<style scoped>
.Addconditions{background: #fff;padding: 20px;}
.conditionsarea{width: 100%;height: 400px;font-size: 14px;padding: 20px;border:none;outline:none;background:#F0F4F7;border-radius: 8px;}
.title{font-size: 14px;font-weight: bold;line-height: 1;}
.title::before{content: '';background:#0088FF;width:2px;display: block;float: left;height: 14px;margin-right: 5px;}
.labellist{display: grid;grid-template-columns: 50px 50px 50px 50px 50px 50px 50px 50px;}
.labellist li{width:40px;height: 40px;background:#B0D6FF;line-height: 40px;text-align: center;margin:5px;cursor: pointer;}
.scale_right_div span {color: rgba(0, 136, 255, 1);margin-left: 10px;}
.scale_right_div i {font-style: normal;}
.scale_right_div .scale_right_input {margin-left: 20px;margin-top: 40px;width: 180px !important;padding-right: 20px;}
.el-checkbox-group{width: 300px;margin-top: 0px;height: 40px;}
.scale_list{margin-top:40px;}
.popover{padding: 10px;}
.popover .list{height: 400px;overflow: auto;padding:20px 0;}
.popover .list .item{padding: 5px;}
.popover .list .item.on{background: #66b1ff;color: #fff;}
.choosebtn{width:100%;padding: 0;}
</style>